import React from "react";
import { IOption } from "../Input/Input";
import classes from "./Star.module.scss";
import StarOption from "./StarOption/StarOption";

interface IProps {
  value: string;
  onChange: (value: string) => void;
  options: IOption[] | undefined;
  disabled?: boolean;
  invalid?: boolean;
}

const Star: React.FC<IProps> = ({ value, onChange, options, disabled, invalid }) => {
  const activeIndex = options?.findIndex(o => o.value === value);
  const containerClasses = [classes.OptionContainer];
  if (invalid) {
    containerClasses.push(classes.Invalid);
  }

  return (
    <div className={containerClasses.join(' ')}>
      {options &&
        options.map((option, i) => (
          <StarOption
            key={option.value}
            value={option.value}
            isActive={i <= (activeIndex ?? -1)}
            onClick={onChange}
            disabled={disabled}
            invalid={invalid}
          />
        ))}
    </div>
  );
};

export default Star;
